export default [
  { label: 'inputType.None', value: 0 },
  { label: 'inputType.Switch1Toggle', value: 1 },
  { label: 'inputType.Switch2Toggle', value: 2 },
  { label: 'inputType.Switch3Toggle', value: 3 },
  { label: 'inputType.Switch4Toggle', value: 4 },
  { label: 'inputType.Switch1On', value: 5 },
  { label: 'inputType.Switch2On', value: 6 },
  { label: 'inputType.Switch3On', value: 7 },
  { label: 'inputType.Switch4On', value: 8 },
  { label: 'inputType.AllSwitchOn', value: 9 },
  { label: 'inputType.Switch1Off', value: 10 },
  { label: 'inputType.Switch2Off', value: 11 },
  { label: 'inputType.Switch3Off', value: 12 },
  { label: 'inputType.Switch4Off', value: 13 },
  { label: 'inputType.AllSwitchOff', value: 14 },
  { label: 'inputType.OpenSensor', value: 15 },
  { label: 'inputType.Dorbell', value: 16 },
  { label: 'inputType.FireAlarm', value: 17 },
  { label: 'inputType.SecurityAlarm', value: 18 },
  { label: 'inputType.TermalSensor', value: 19 },
  { label: 'inputType.MoveSensor', value: 20 },
  { label: 'inputType.OtherSensor', value: 21 },
  { label: 'inputType.IntrusionDetection', value: 22 }
]




// WEBPACK FOOTER //
// ./src/components/controller/inputTypes.js